import { render } from "./main_ubuntu.vue?vue&type=template&id=a806972a&scoped=true"
import script from "./main_ubuntu.vue?vue&type=script&lang=js"
export * from "./main_ubuntu.vue?vue&type=script&lang=js"

import "./main_ubuntu.vue?vue&type=style&index=0&id=a806972a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a806972a"]])

export default __exports__